import React from 'react'
import cls from 'classnames'

import permManager from 'utils/permManager'

import AnnouncementEditor from 'containers/Settings/Notifications/EndUser/Editor'
import AnnouncementLogo from 'containers/Settings/Notifications/EndUser/Logo'

import DataContainer from 'components/elements/DataContainer'
import GroupSettingsBanner from 'components/elements/GroupSettingsBanner'
import SettingsHeader from 'components/elements/SettingsHeader'

import AddLanguage from './selector/AddLanguage'
import AnnouncementList from './AnnouncementList'

require('components/styles/layouts/settings/notifications.styl')

class EndUserNotifications extends React.Component {
  state = {
    error: null,
    showLanguageDialog: false,
    localeId: 0,
  }

  componentDidMount() {
    const { isGroupSettings } = this.props
    if (!isGroupSettings) this.props.fetchData()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        error: { ...nextProps.error, refreshAction: this.props.fetchData },
      })
    } else if (this.state.error) {
      this.setState({ error: null })
    }

    this.setState({ localeId: nextProps.locale.locale_id })
  }

  componentWillUnmount() {
    const { isGroupSettings } = this.props
    if (!isGroupSettings) this.props.fetchDataCancel()
  }

  onNewLanguageSelect = (localeId) => {
    this.setState({ showLanguageDialog: false })
    this.props.addLanguage(localeId)
  }

  getLanguageOptions = () => {
    let options = this.props.languages
    const item = this.props.items[this.props.activeIndex]
    if (!options || !item) {
      return []
    }
    options = options.filter((lang) => item.locales.includes(lang.value))
    options.push({ label: 'Add Language', value: '-1' })
    return options
  }

  handleOnLanguageChange = (languageId) => {
    if (Number(languageId) === -1) {
      this.setState({ showLanguageDialog: true })
      return
    }
    this.setState({ localeId: languageId })
    this.props.fetchLocale({ locale_id: languageId })
  }

  handleModalClose = () => {
    this.setState({ showLanguageDialog: false })
  }

  newLanguageOptions = () => {
    let options = this.props.languages
    const item = this.props.items[this.props.activeIndex]
    if (!options || !item) {
      return []
    }
    options = options.filter((lang) => !item.locales.includes(lang.value))
    return options
  }

  render() {
    const {
      items,
      loader,
      activeIndex,
      languages,
      locale,
      selectAnnouncement,
      updateData,
      deleteLocale,
      companyFilter,
      permissions,
      isGroupSettings,
      groupSettingsNameByPartner,
      selectedRecipients,
    } = this.props
    const { error, localeId, showLanguageDialog } = this.state

    return (
      <div className={cls('card pz', { scrollable: !loader })} id="Settings_ScrollToTop_card">
        <SettingsHeader header="Notifications Settings" subHeader="End-User Alerts" />
        <DataContainer
          error={error}
          loader={loader}
          className={cls('announcements', { 'with-loader': true })}
          partnerAccess={{
            companyFilter,
            checkPartnerAccess: permManager.pages.settings.notifications.self,
          }}
        >
          <div style={{ margin: '15px' }}>
            <GroupSettingsBanner isGroupSettingsFlow={isGroupSettings} />
          </div>

          <div
            className={cls('announcements-content-container', {
              disabled_for_edit: !isGroupSettings && groupSettingsNameByPartner,
            })}
          >
            <span className="settings-section-title">Notification Customization</span>
            <div className="card announcements-content">
              <div className="announcement-left-side">
                <div className="report-list-positioner">
                  <AnnouncementList
                    items={items}
                    languages={languages}
                    selectAnnouncement={selectAnnouncement}
                    updateData={updateData}
                    activeIndex={activeIndex}
                  />
                </div>
              </div>
              <div className="announcement-right-side">
                <AnnouncementEditor
                  text="1"
                  template="1"
                  announcement_id={items[activeIndex] ? items[activeIndex].id : null}
                  activeLocales={items[activeIndex] ? items[activeIndex].locales : []}
                  onChange={this.handleChangeInput}
                  languages={languages}
                  locale={locale}
                  deleteLocale={deleteLocale}
                  trigger={items[activeIndex] ? items[activeIndex].trigger : null}
                  localeId={localeId}
                  handleOnLanguageChange={this.handleOnLanguageChange}
                  getLanguageOptions={this.getLanguageOptions}
                  permissions={permissions}
                  isGroupSettings={isGroupSettings}
                  selectedRecipients={selectedRecipients}
                />
              </div>
            </div>

            <span style={{ marginTop: '40px' }} className="settings-section-title">
              Logo Customization
            </span>
            <div className="announcements-logo-customization">
              <AnnouncementLogo isGroupSettings={isGroupSettings} />
            </div>
          </div>

          <AddLanguage
            className="modal_placeholder"
            newLanguageOptions={this.newLanguageOptions()}
            showDialog={showLanguageDialog}
            onNewLanguageSelect={this.onNewLanguageSelect}
            handleModalClose={this.handleModalClose}
          />
        </DataContainer>
      </div>
    )
  }
}

export default EndUserNotifications
